import React from "react";

const FONT_LINK =
  "https://fonts.googleapis.com/css2?family=Oswald:wght@500;700&display=swap";

function useGoogleFont(href) {
  if (typeof document !== "undefined") {
    if (!document.querySelector(`link[href="${href}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
    }
  }
}

export default function PinterestPinTemplate10({
  foodImageUrl1,
  foodImageUrl2,
  title = "Fresh Raspberry Cloud Mousse",
  focusKeyword
}) {
  useGoogleFont(FONT_LINK);

  const displayTitle = focusKeyword || title;
  const bgImage2 = foodImageUrl2 || foodImageUrl1;

  return (
    <div
      id="pinterest-pin-template"
      style={{
        width: 474,
        height: 948,
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#000",
        WebkitFontSmoothing: "antialiased"
      }}
    >
      {/* ===== TOP IMAGE ===== */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width: 474,
          height: 474,
          backgroundImage: foodImageUrl1
            ? `url(${foodImageUrl1})`
            : "none",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundColor: "#d6b38a"
        }}
      />

      {/* ===== BOTTOM IMAGE ===== */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 474,
          width: 474,
          height: 474,
          backgroundImage: bgImage2
            ? `url(${bgImage2})`
            : "none",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundColor: "#b89060"
        }}
      />

      {/* ===== DOODLE CTA ARROW (bottom-left, below banner) ===== */}
      {/*
        Root cause of previous failure: markerEnd="url(#...)" references a <defs> marker,
        which html2canvas does not support — it silently drops the element.
        Fix: arrowhead drawn as an inline <polygon> (no defs, no url refs).
        Polygon coords computed from the path's end tangent at (62,37): direction ≈ (0.14,−0.99).
        tip=(62,37)  left-base=(53,52)  right-base=(67,54)
      */}
      <svg
        style={{
          position: "absolute",
          left: 20,
          top: 762,
          zIndex: 20,
          pointerEvents: "none"
        }}
        width="110"
        height="128"
        viewBox="0 0 110 128"
        fill="none"
      >
        {/* White glow — keeps arrow legible on dark food images */}
        <path
          d="M 35,118 C 8,98 4,63 20,40 C 36,18 63,15 80,31 C 97,47 92,77 72,88 C 55,98 37,89 40,73 C 43,57 60,51 62,37"
          stroke="#ffffff"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />

        {/* Black dashed spiral line */}
        <path
          d="M 35,118 C 8,98 4,63 20,40 C 36,18 63,15 80,31 C 97,47 92,77 72,88 C 55,98 37,89 40,73 C 43,57 60,51 62,37"
          stroke="#000000"
          strokeWidth="2.8"
          strokeDasharray="8 5"
          strokeLinecap="round"
          fill="none"
        />

        {/* Inline arrowhead polygon — html2canvas renders this reliably */}
        <polygon points="62,37 53,52 67,54" fill="#000000" />
      </svg>

      {/* ===== CURVED LUXURY BANNER ===== */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 474,
          zIndex: 10
        }}
      >
        {/* Curved black banner */}
        <div
          style={{
            position: "relative",
            background: "#111111",
            borderTop: "4px solid #D4AF37",
            borderBottom: "4px solid #D4AF37",
            borderRadius: "0 0 70px 70px / 0 0 18px 18px",
            padding: "28px 28px 30px",
            overflow: "hidden"
          }}
        >
          {/* Curved top */}
          <div
            style={{
              position: "absolute",
              top: -22,
              left: -20,
              width: 514,
              height: 44,
              borderTop: "4px solid #D4AF37",
              borderRadius: "50%",
              pointerEvents: "none"
            }}
          />

          {/* Stars */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 6,
              marginBottom: 14
            }}
          >
            {Array.from({ length: 5 }).map((_, index) => (
              <span
                key={index}
                style={{
                  color: "#D4AF37",
                  fontSize: 18,
                  lineHeight: 1
                }}
              >
                ★
              </span>
            ))}
          </div>

          {/* Title */}
          <div
            style={{
              fontFamily:
                '"Oswald", "Impact", "Arial Narrow", sans-serif',
              fontSize: 42,
              fontWeight: 700,
              color: "#FFFFFF",
              textAlign: "center",
              lineHeight: 1.05,
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              maxWidth: "100%"
            }}
          >
            {displayTitle}
          </div>
        </div>
      </div>
    </div>
  );
}